import { Injectable } from '@angular/core';
import { Location } from '@angular/common';
var PopStateService = /** @class */ (function () {
    function PopStateService(location) {
        var _this = this;
        this.location = location;
        this.actionBack = false;
        location.subscribe(function (event) {
            var url = event.url;
            if (_this.actionBack && url.match(/^\/login/)) {
                _this.location.replaceState('/top');
            }
            _this.setActionBack(false);
        });
    }
    PopStateService.prototype.setActionBack = function (flg) {
        this.actionBack = flg;
    };
    PopStateService.decorators = [
        { type: Injectable }
    ];
    /** @nocollapse */
    PopStateService.ctorParameters = function () { return [
        { type: Location }
    ]; };
    return PopStateService;
}());
export { PopStateService };
//# sourceMappingURL=popstate.service.js.map